const allowedKeycapFields = [
  'profiles',
  'keycapId',
  'width',
  'height',
  'group',
  'colorGroup',
  'isSpacer',
  'isConvex',
  'isOffCentered',
  'isIsoEnter',
  'hasHomingBar',
  'stepped',
  'row',
  'xOffset',
  'yOffset',
  'rotation',
  'rotationCenterX',
  'rotationCenterY',
]; // fields that are allowed by the keycap schema

const spacerAllowedFields = ['width', 'height', 'isSpacer']; // spacers should only contain fields that affect spacing

const booleanKeycapFields = [
  'isSpacer',
  'isConvex',
  'isOffCentered',
  'isIsoEnter',
  'hasHomingBar',
  'stepped',
]; // fields that must be boolean when they are present

const numericKeycapFields = [
  'width',
  'height',
  'colorGroup',
  'xOffset',
  'yOffset',
  'rotation',
  'rotationCenterX',
  'rotationCenterY',
]; // fields that must be numbers when they are present

const stringKeycapFields = ['keycapId', 'group', 'row']; // fields that must be strings when they are present

const allowedGroups = [
  'modifier',
  'alphanumeric',
  'function',
  'navigation',
  'numpad',
]; // groups supported by the layout editor color view

const allowedRows = [
  'R1',
  'R1-1',
  'R1-2',
  'R2',
  'R2-3',
  'R3',
  'R3-4',
  'R4',
  'R4-4',
  'Uniform',
]; // row values supported by the layout editor row view

export const validKeycapsByTypeKey = {
  '1x1': {
    label: '1u',
    xdaKeycapId: '668d57fc59b095bed85b2cc8',
  },
  '1x1-homing-bar': {
    label: '1u (homing bar)',
    xdaKeycapId: '668d59b1ed804aa7c00f8d61',
  },
  '1.25x1': {
    label: '1.25u',
    xdaKeycapId: '668d59d0ed804aa7c00f8d69',
  },
  '1.5x1': {
    label: '1.5u',
    xdaKeycapId: '668d59f6ed804aa7c00f8d71',
  },
  '1.75x1': {
    label: '1.75u',
    xdaKeycapId: '668d5a07ed804aa7c00f8d79',
  },
  '1.75x1-stepped': {
    label: '1.75u (stepped)',
    xdaKeycapId: '668d5a13ed804aa7c00f8d81',
  },
  '2x1': {
    label: '2u',
    xdaKeycapId: '668d5a2ded804aa7c00f8d8e',
  },
  '1x2': {
    label: '2u (vertical)',
    xdaKeycapId: '668d5a2ded804aa7c00f8d8e',
  },
  '2.25x1': {
    label: '2.25u',
    xdaKeycapId: '668d5a3aed804aa7c00f8d96',
  },
  '2.75x1': {
    label: '2.75u',
    xdaKeycapId: '668d5a51ed804aa7c00f8d9e',
  },
  '1.5x2-iso-enter': {
    label: 'ISO Enter',
    xdaKeycapId: '668d5a6bed804aa7c00f8da6',
  },
  '1x1-convex': {
    label: '1u (convex)',
    xdaKeycapId: '668d5aefed804aa7c00f8db7',
  },
  '1.25x1-convex': {
    label: '1.25u (convex)',
    xdaKeycapId: '668d5b13ed804aa7c00f8dbf',
  },
  '1.75x1-convex': {
    label: '1.75u (convex)',
    xdaKeycapId: '668d5b29ed804aa7c00f8dc7',
  },
  '2x1-convex': {
    label: '2u (convex)',
    xdaKeycapId: '668d5b45ed804aa7c00f8dd4',
  },
  '2.25x1-convex': {
    label: '2.25u (convex)',
    xdaKeycapId: '668d5b6aed804aa7c00f8ddc',
  },
  '2.75x1-convex': {
    label: '2.75u (convex)',
    xdaKeycapId: '668d5b7fed804aa7c00f8de4',
  },
  '3x1-convex': {
    label: '3u (convex)',
    xdaKeycapId: '668d5b9aed804aa7c00f8dec',
  },
  '3.25x1-convex': {
    label: '3.25u (convex)',
    xdaKeycapId: '668d67fa3a60951ad912dcee',
  },
  '4.5x1-convex': {
    label: '4.5u (convex)',
    xdaKeycapId: '668d5c05ed804aa7c00f8df4',
  },
  '6x1-convex': {
    label: '6u (convex)',
    xdaKeycapId: '668d65e33a60951ad912994a',
  },
  '6x1-convex-off-centered': {
    label: '6u (convex + off-centered)',
    xdaKeycapId: '668d65fe3a60951ad9129952',
  },
  '6.25x1-convex': {
    label: '6.25u (convex)',
    xdaKeycapId: '668d66243a60951ad912995a',
  },
  '7x1-convex': {
    label: '7u (convex)',
    xdaKeycapId: '668d66423a60951ad9129962',
  },
}; // all valid physical keycap types and their required XDA keycap document IDs

const allowedKeycapIds = [
  'KC_ESC',
  'KC_F1',
  'KC_F2',
  'KC_F3',
  'KC_F4',
  'KC_F5',
  'KC_F6',
  'KC_F7',
  'KC_F8',
  'KC_F9',
  'KC_F10',
  'KC_F11',
  'KC_F12',
  'KC_F13',
  'KC_F14',
  'KC_F15',
  'KC_F16',
  'KC_F17',
  'KC_F18',
  'KC_F19',
  'KC_GRV',
  'KC_1',
  'KC_2',
  'KC_3',
  'KC_4',
  'KC_5',
  'KC_6',
  'KC_7',
  'KC_8',
  'KC_9',
  'KC_0',
  'KC_MINS',
  'KC_EQL',
  'KC_BSPC',
  'KC_INS',
  'KC_HOME',
  'KC_PGUP',
  'KC_NUM',
  'KC_PSLS',
  'KC_PAST',
  'KC_PMNS',
  'KC_TAB',
  'KC_Q',
  'KC_W',
  'KC_E',
  'KC_R',
  'KC_T',
  'KC_Y',
  'KC_U',
  'KC_I',
  'KC_O',
  'KC_P',
  'KC_LBRC',
  'KC_RBRC',
  'KC_BSLS',
  'KC_DEL',
  'KC_END',
  'KC_PGDN',
  'KC_P7',
  'KC_P8',
  'KC_P9',
  'KC_PPLS',
  'KC_CAPS',
  'KC_A',
  'KC_S',
  'KC_D',
  'KC_F',
  'KC_G',
  'KC_H',
  'KC_J',
  'KC_K',
  'KC_L',
  'KC_SCLN',
  'KC_QUOT',
  'KC_ENT',
  'KC_P4',
  'KC_P5',
  'KC_P6',
  'KC_LSFT',
  'KC_Z',
  'KC_X',
  'KC_C',
  'KC_V',
  'KC_B',
  'KC_N',
  'KC_M',
  'KC_COMM',
  'KC_DOT',
  'KC_SLSH',
  'KC_RSFT',
  'KC_UP',
  'KC_P1',
  'KC_P2',
  'KC_P3',
  'KC_PENT',
  'KC_LCTL',
  'KC_LGUI',
  'KC_LALT',
  'KC_SPC',
  'KC_RALT',
  'KC_RGUI',
  'KC_APP',
  'KC_RCTL',
  'KC_LEFT',
  'KC_DOWN',
  'KC_RGHT',
  'KC_P0',
  'KC_PDOT',
  'KC_NUBS',
  'KC_NUHS',
]; // all keycapId values that are supported by the layout data

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value); // checks whether a value is a normal object

export const hasOwnField = (object, field) =>
  Object.prototype.hasOwnProperty.call(object, field); // checks whether a field really exists on the object

const isFiniteNumber = (value) =>
  typeof value === 'number' && Number.isFinite(value); // checks whether a value is a usable number

const addLayoutValidationProblem = (problems, path, message) => {
  problems.push({
    path,
    message,
  }); // store one validation problem with its exact layout path
}; // adds one layout validation problem to the result list

const getKeycapSizeKey = (keycap) =>
  `${Number(keycap.width)}x${Number(keycap.height)}`; // creates a comparable size key like "1.25x1"

export const getKeycapTypeKey = (keycap) => {
  const sizeKey = getKeycapSizeKey(keycap); // create a size key like "2x1" or "1x2"
  const typeParts = [sizeKey]; // start with the physical dimensions

  if (keycap.isConvex) {
    typeParts.push('convex'); // convex keycaps use different XDA documents
  }

  if (keycap.isOffCentered) {
    typeParts.push('off-centered'); // only available for specific convex keycaps
  }

  if (keycap.isIsoEnter) {
    typeParts.push('iso-enter'); // ISO Enter is another physical property
  }

  if (keycap.hasHomingBar) {
    typeParts.push('homing-bar'); // homing bar changes the physical keycap
  }

  if (keycap.stepped) {
    typeParts.push('stepped'); // stepped changes the physical keycap
  }

  return typeParts.join('-');
}; // creates a complete physical keycap type lookup key

const validateProfiles = (keycap, path, problems, validKeycapType) => {
  if (!hasOwnField(keycap, 'profiles')) {
    addLayoutValidationProblem(
      problems,
      `${path}.profiles`,
      'echte Keycaps müssen profiles enthalten.'
    );
    return; // stop here because the required profile/keycap-id pair is missing
  }

  if (!isPlainObject(keycap.profiles)) {
    addLayoutValidationProblem(
      problems,
      `${path}.profiles`,
      'profiles muss ein Objekt sein.'
    );
    return; // stop here because profile entries cannot be checked safely
  }

  const profileEntries = Object.entries(keycap.profiles); // get all profile/keycap-id pairs from the profiles object

  if (profileEntries.length !== 1 || !hasOwnField(keycap.profiles, 'XDA')) {
    addLayoutValidationProblem(
      problems,
      `${path}.profiles`,
      'profiles muss aktuell genau ein Profil enthalten: XDA.'
    );
    return; // stop here because only XDA is supported at the moment
  }

  const xdaKeycapId = keycap.profiles.XDA;

  if (!xdaKeycapId || typeof xdaKeycapId !== 'string') {
    addLayoutValidationProblem(
      problems,
      `${path}.profiles.XDA`,
      'profiles.XDA muss eine nicht-leere Keycap-Dokument-ID als String sein.'
    );
    return; // stop here because the value cannot be compared safely
  }

  if (!validKeycapType) {
    return; // stop here because there is no valid keycap type to compare against
  }

  if (xdaKeycapId !== validKeycapType.xdaKeycapId) {
    addLayoutValidationProblem(
      problems,
      `${path}.profiles.XDA`,
      `profiles.XDA muss für ${validKeycapType.label} "${validKeycapType.xdaKeycapId}" sein.`
    );
  }
}; // validates that every real keycap has exactly the supported XDA profile and the correct keycap document ID

const validateKeycapType = (keycap, path, problems) => {
  const keycapTypeKey = getKeycapTypeKey(keycap); // build the complete physical keycap identity
  const validKeycapType = validKeycapsByTypeKey[keycapTypeKey]; // find the allowed physical keycap type

  if (!validKeycapType) {
    addLayoutValidationProblem(
      problems,
      path,
      `dieser Keycap-Typ ist nicht erlaubt: ${keycapTypeKey}.`
    );

    return null; // stop profile validation because the physical type is invalid
  }

  return validKeycapType; // return the expected XDA document information
}; // validates the physical keycap combination against the allowed keycap types

const validateSpacerObject = (keycap, path, problems) => {
  Object.keys(keycap).forEach((field) => {
    if (!spacerAllowedFields.includes(field)) {
      addLayoutValidationProblem(
        problems,
        `${path}.${field}`,
        `spacer dürfen das Feld "${field}" nicht enthalten.`
      );
    }
  });

  if (keycap.isSpacer !== true) {
    addLayoutValidationProblem(
      problems,
      `${path}.isSpacer`,
      'spacer müssen isSpacer: true haben.'
    );
  }

  if (!hasOwnField(keycap, 'width') || !isFiniteNumber(keycap.width)) {
    addLayoutValidationProblem(
      problems,
      `${path}.width`,
      'spacer müssen eine numerische width haben.'
    );
  }

  if (!hasOwnField(keycap, 'height') || !isFiniteNumber(keycap.height)) {
    addLayoutValidationProblem(
      problems,
      `${path}.height`,
      'spacer müssen eine numerische height haben.'
    );
  }

  if (
    isFiniteNumber(keycap.width) &&
    isFiniteNumber(keycap.height) &&
    keycap.width === 0 &&
    keycap.height === 0
  ) {
    addLayoutValidationProblem(
      problems,
      path,
      'spacer dürfen nicht gleichzeitig width: 0 und height: 0 haben.'
    );
  }
}; // validates spacer objects and prevents keycap-only fields on spacers

const validateKeycapMetadata = (keycap, path, problems) => {
  // validates optional keycapId values
  if (
    hasOwnField(keycap, 'keycapId') &&
    !allowedKeycapIds.includes(keycap.keycapId)
  ) {
    addLayoutValidationProblem(
      problems,
      `${path}.keycapId`,
      `keycapId "${keycap.keycapId}" ist nicht erlaubt.`
    );
  }

  // validates keycap group value
  if (!allowedGroups.includes(keycap.group)) {
    addLayoutValidationProblem(
      problems,
      `${path}.group`,
      `group muss einer dieser Werte sein: ${allowedGroups.join(', ')}.`
    );
  }

  // validates color group value
  if (![1, 2, 3].includes(keycap.colorGroup)) {
    addLayoutValidationProblem(
      problems,
      `${path}.colorGroup`,
      'colorGroup muss die Zahl 1, 2 oder 3 sein.'
    );
  }

  // validates row value
  if (!allowedRows.includes(keycap.row)) {
    addLayoutValidationProblem(
      problems,
      `${path}.row`,
      `row muss einer dieser Werte sein: ${allowedRows.join(', ')}.`
    );
  }
}; // validates non-physical keycap metadata

const validateRealKeycapObject = (keycap, path, problems) => {
  const validKeycapType = validateKeycapType(keycap, path, problems); // validates the physical keycap combination

  validateProfiles(keycap, path, problems, validKeycapType); // validates that the XDA profile matches the physical keycap

  validateKeycapMetadata(keycap, path, problems); // validates keycapId, group, colorGroup and row
}; // validates real keycap objects

const validateKeycapObject = (keycap, path, problems) => {
  if (!isPlainObject(keycap)) {
    addLayoutValidationProblem(
      problems,
      path,
      'jeder Eintrag innerhalb einer Row muss ein Objekt sein.'
    );
    return; // stop here because non-object keycaps cannot be checked safely
  }

  if (Object.keys(keycap).length === 0) {
    addLayoutValidationProblem(
      problems,
      path,
      'leere Objekte sind im Layout nicht erlaubt.'
    );
    return; // empty objects do not contain enough data to be a keycap or spacer
  }

  Object.keys(keycap).forEach((field) => {
    if (!allowedKeycapFields.includes(field)) {
      addLayoutValidationProblem(
        problems,
        `${path}.${field}`,
        `unbekanntes Feld "${field}".`
      );
    }
  });

  booleanKeycapFields.forEach((field) => {
    if (hasOwnField(keycap, field) && keycap[field] !== true) {
      addLayoutValidationProblem(
        problems,
        `${path}.${field}`,
        `${field} darf nur true sein. Entferne das Feld, wenn es nicht benötigt wird.`
      );
    }
  });

  numericKeycapFields.forEach((field) => {
    if (hasOwnField(keycap, field) && !isFiniteNumber(keycap[field])) {
      addLayoutValidationProblem(
        problems,
        `${path}.${field}`,
        `${field} muss eine gültige Zahl sein.`
      );
    }
  });

  ['xOffset', 'yOffset', 'rotation'].forEach((field) => {
    if (hasOwnField(keycap, field) && keycap[field] === 0) {
      addLayoutValidationProblem(
        problems,
        `${path}.${field}`,
        `${field} darf nicht 0 sein. Entferne das Feld, wenn es nicht benötigt wird.`
      );
    }
  });

  if (
    hasOwnField(keycap, 'rotationCenterX') &&
    !hasOwnField(keycap, 'rotation')
  ) {
    addLayoutValidationProblem(
      problems,
      `${path}.rotationCenterX`,
      'rotationCenterX darf nur gesetzt werden, wenn rotation gesetzt ist.'
    );
  }

  if (
    hasOwnField(keycap, 'rotationCenterY') &&
    !hasOwnField(keycap, 'rotation')
  ) {
    addLayoutValidationProblem(
      problems,
      `${path}.rotationCenterY`,
      'rotationCenterY darf nur gesetzt werden, wenn rotation gesetzt ist.'
    );
  }

  stringKeycapFields.forEach((field) => {
    if (hasOwnField(keycap, field) && typeof keycap[field] !== 'string') {
      addLayoutValidationProblem(
        problems,
        `${path}.${field}`,
        `${field} muss ein String sein.`
      );
    }
  });

  if (hasOwnField(keycap, 'isSpacer')) {
    validateSpacerObject(keycap, path, problems);
    return; // objects with isSpacer are always treated as spacers
  }

  validateRealKeycapObject(keycap, path, problems);
}; // validates one object inside a layout row

export const validateLayoutStructure = (layoutToValidate) => {
  const problems = []; // stores all validation problems found in the layout

  if (!Array.isArray(layoutToValidate)) {
    addLayoutValidationProblem(
      problems,
      'layout',
      'layout muss ein Array aus Rows sein.'
    );
    return problems; // stop here because rows cannot be checked safely
  }

  if (layoutToValidate.length === 0) {
    addLayoutValidationProblem(
      problems,
      'layout',
      'layout muss mindestens eine Row enthalten.'
    );
    return problems; // stop here because there are no rows to check
  }

  let realKeycapCount = 0; // counts real keycaps so completely empty layouts can be detected

  layoutToValidate.forEach((row, rowIndex) => {
    const rowPath = `layout[${rowIndex}]`;

    if (!Array.isArray(row)) {
      addLayoutValidationProblem(
        problems,
        rowPath,
        'jede Row muss ein Array sein.'
      );
      return; // stop this row because keycaps cannot be checked safely
    }

    if (row.length === 0) {
      addLayoutValidationProblem(
        problems,
        rowPath,
        'leere Rows sind nicht erlaubt.'
      );
      return; // empty rows do not contain keycaps or spacers
    }

    let realKeycapCountInRow = 0; // counts real keycaps inside the current row
    let previousObjectWasSpacer = false; // tracks whether the previous object inside this row was a spacer

    row.forEach((keycap, keycapIndex) => {
      const keycapPath = `${rowPath}[${keycapIndex}]`;
      const currentObjectIsSpacer =
        isPlainObject(keycap) && keycap.isSpacer === true; // only real spacer objects count for the consecutive spacer check

      if (currentObjectIsSpacer && previousObjectWasSpacer) {
        addLayoutValidationProblem(
          problems,
          keycapPath,
          'zwei Spacer direkt hintereinander sind innerhalb einer Row nicht erlaubt.'
        );
      }

      if (
        isPlainObject(keycap) &&
        Object.keys(keycap).length > 0 &&
        keycap.isSpacer !== true
      ) {
        realKeycapCount += 1; // count only real keycaps, not spacers
        realKeycapCountInRow += 1; // count only real keycaps inside this row
      }

      validateKeycapObject(keycap, keycapPath, problems);

      previousObjectWasSpacer = currentObjectIsSpacer; // update the spacer tracker for the next object in this row
    });

    if (realKeycapCountInRow === 0) {
      addLayoutValidationProblem(
        problems,
        rowPath,
        'jede Row muss mindestens eine echte Keycap enthalten.'
      );
    }
  });

  if (realKeycapCount === 0) {
    addLayoutValidationProblem(
      problems,
      'layout',
      'layout muss mindestens eine echte Keycap enthalten.'
    );
  }

  return problems;
}; // validates the full layout structure and all keycap/spacer values
